"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crewUpdate = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageParticles_sidecar_1 = require("@voyage/particles/voyageParticles-sidecar");
var voyageSystems_sidecar_1 = require("@voyage/systems/voyageSystems-sidecar");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
function crewUpdate(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    var useSystemTime = 0.5;
    d.useSystemTimer += ds;
    diveCrew_hero_sidecar_1.diveCrew_hero.setProgress(obj, d.useSystemTimer / useSystemTime);
    if (d.useSystemTimer > useSystemTime) {
        d.useSystemTimer -= useSystemTime;
        if (voyageSystems_sidecar_1.voyageSystems.testNoPower(obj)) {
            return;
        }
        var tHere = voyageTilemap_sidecar_1.voyageTilemap.getSafeIJ(obj);
        if (tHere) {
            var sys = voyageTilemap_sidecar_1.voyageTilemap.getSystemByKeySafe(('' + tHere.text3).replace('med', 'pad'));
            if (sys) {
                voyageParticles_sidecar_1.voyageParticles.createMultiple('heal', sys.x, sys.y, 1);
                // let toHeal = diveCrew.getAt(
                //   sys,
                //   (c) => c.type === EVoyageCrewType.Crew,
                // )
                // if (toHeal && !toHeal.isDying) {
                //   let healRate = 10
                //   toHeal.hitpoints += useSystemTime * healRate
                //   if (toHeal.hitpoints > 100) {
                //     toHeal.hitpoints = 100
                //   }
                // }
            }
        }
    }
}
exports.crewUpdate = crewUpdate;
